import { QueryClient } from "@tanstack/svelte-query";

/**
 * Shared QueryClient singleton for all islands.
 *
 * Injected into every island's props by bootstrap.ts. Each island
 * passes it to <QueryClientProvider client={queryClient}> to populate
 * Svelte context for child components using createQuery() / useQueryClient().
 *
 * Using a single instance means all islands share the same query cache,
 * enabling cross-island cache deduplication and invalidation.
 */
export const sharedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: true,
    },
  },
});
